import { Deserializable } from "../shared/models/deserializable.model";
import { AccountFile } from "../models/account-file";

export class GalleryPhoto implements Deserializable {
  id: number;
  title: string;
  description: string;
  accountFileId: number;
  galleryId: number;
  createdAt: Date;
  updatedAt: Date;
  AccountFile: AccountFile;

  deserialize(input: any) {
    Object.assign(this, input);
    if (input.AccountFile) {
      this.AccountFile = new AccountFile().deserialize(input.AccountFile);
    }
    return this;
  }
} 